import vue from "vue";

import {getCompanyPage} from "../../../services/systemCompany"

const state = {
  dataPages: [],
  total: 0,
  paginationInit: {current: 1, size: 10},
  filterInit:{}
}

const getters = {
  dataPages: () => state.dataPages,
  total: () => state.total,
  paginationInit: () => state.paginationInit,
  filterInit: () => state.filterInit,
}

const actions = {
  //分页列表
  getCompanyPage({commit, dispatch}, objc) {
    getCompanyPage({...state.filterInit,...state.paginationInit}).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'dataPages', update: res.data.records});
        commit('updateState', {state: 'total', update: res.data.total})
      }
    }
  )
  }
}

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/system/modules/systemCompany.js